/** Shown when add deployment is disabled because the version is a flattened (dev/qa) API */
export const FLATTENED_API_DEPLOYMENT_DISABLED_MESSAGE =
  "Regional deployments are not allowed for dev and qa APIs";

export interface DeploymentCreatorProps {
  resourceAppName: string;
  resourceAppId: string;
  version: string;
  refreshDeploymentList: () => void;
  deployedRegions: string[] | undefined;
  basePath: string;
  onDeploymentAdded?: () => void;
  /** From GET /:consumerKey/version/:version; when true, new deployments are not allowed */
  isFlattenedApi?: boolean;
}
